import React from "react";
import {
  Stethoscope,
  Mail,
  Phone,
  ArrowRight,
  UserPlus,
} from "lucide-react";
import { motion } from "framer-motion";

const Contact = () => {

  return (
    <motion.section
      id="Contact"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.8,
        ease: "easeOut"
      }}
      viewport={{ once: true, amount: 0.2 }}
      className="bg-[#F8FAFF] py-12 md:py-16 lg:py-20 relative overflow-hidden"
    >
      {/* Background Glow - softer and lighter */}
      <div className="absolute top-[-5%] left-[-5%] w-[250px] h-[250px] bg-[#4169E108] rounded-full blur-3xl"></div>
      <div className="absolute bottom-[-5%] right-[-5%] w-[250px] h-[250px] bg-[#16A34A08] rounded-full blur-3xl"></div>

      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 relative z-10">

        {/* Header - compact version */}
        <div className="text-center">
          {/* Pill Header - unchanged (as requested) */}
          <div className="flex justify-center mb-6 md:mb-8">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-royalBlue/10 to-royalBlue/5 backdrop-blur-sm rounded-full px-4 py-1.5 sm:px-5 md:px-6 sm:py-2 border border-royalBlue/20 shadow-md">
              <UserPlus size={16} className="text-royalGreen sm:size-[18px]" />
              <p className="font-poppins font-semibold text-royalBlue text-xs sm:text-sm md:text-base tracking-wide uppercase whitespace-nowrap">
                CONTACT / SIGN UP
              </p>
            </div>
          </div>

          <h2 className="font-poppins font-bold text-darkblue leading-tight text-2xl sm:text-3xl md:text-4xl lg:text-5xl tracking-tight">
            Join Livmo
          </h2>

          <p className="mt-4 max-w-2xl mx-auto text-text1/80 leading-relaxed font-poppins text-sm sm:text-base md:text-lg">
            Partner with Livmo as a healthcare
            provider and become part of a trusted healthcare coordination
            ecosystem across india
          </p>
        </div>

        {/* Main Card - lighter, more compact */}
        <div className="mt-8 md:mt-10 bg-white border border-gray-200 rounded-2xl shadow-lg overflow-hidden">

          <div className="grid lg:grid-cols-2">

            {/* LEFT SIDE - Light gradient, reduced padding */}
            <div className="relative bg-gradient-to-br from-royalBlue/90 to-royalBlue/70 p-6 md:p-8 lg:p-10 overflow-hidden">

              {/* Decorative circles - lighter opacity */}
              <div className="absolute bottom-[-10%] right-[-10%] w-[180px] h-[180px] bg-white/5 rounded-full"></div>
              <div className="absolute top-[5%] right-[5%] w-[80px] h-[80px] bg-white/5 rounded-full"></div>

              <div className="relative z-10">

                <h3 className="text-white font-poppins font-bold leading-tight text-xl sm:text-2xl md:text-3xl">
                  Healthcare Partnerships Made Simple
                </h3>

                <p className="mt-3 text-white/80 leading-relaxed font-poppins text-sm sm:text-base">
                  Livmo helps corporates and healthcare providers collaborate
                  through a trusted healthcare coordination platform across
                  India.
                </p>

                {/* Info Cards - smaller, tighter */}
                <div className="mt-6 space-y-3">

                  {/* <div className="bg-white/10 backdrop-blur-sm border border-white/10 rounded-xl p-3 sm:p-4">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-xl bg-white/15 flex items-center justify-center shrink-0">
                        <Building2 size={18} className="text-white" />
                      </div>
                      <div>
                        <h4 className="text-white font-poppins font-bold text-sm sm:text-base">
                          For Corporates
                        </h4>
                        <p className="text-white/70 text-xs sm:text-sm mt-0.5 leading-snug">
                          Employee healthcare coordination support.
                        </p>
                      </div>
                    </div>
                  </div> */}

                  <div className="bg-white/10 backdrop-blur-sm border border-white/10 rounded-xl p-3 sm:p-4">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-xl bg-white/15 flex items-center justify-center shrink-0">
                        <Stethoscope size={18} className="text-white" />
                      </div>
                      <div>
                        <h4 className="text-white font-poppins font-bold text-sm sm:text-base">
                          For Providers
                        </h4>
                        <p className="text-white/70 text-xs sm:text-sm mt-0.5 leading-snug">
                          Reach corporate employees through Livmo.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Contact Info - compact */}
                <div className="mt-6 border-t border-white/15 pt-4 space-y-3">

                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center">
                      <Phone size={14} className="text-white" />
                    </div>
                    <p className="text-white font-poppins text-sm sm:text-base">
                      For Sales: +91 72009 95976
                    </p>
                  </div>

                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center">
                      <Phone size={14} className="text-white" />
                    </div>
                    <p className="text-white font-poppins text-sm sm:text-base">
                      For Provider & Support: +91 95004 75976
                    </p>
                  </div>

                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center">
                      <Mail size={14} className="text-white" />
                    </div>
                    <p className="text-white font-poppins text-sm sm:text-base">
                      info@livmohealth.com
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT SIDE - Compact form area */}
            <div className="p-6 md:p-8">

              {/* Tabs - smaller, cleaner */}
              {/* <div className="bg-gray-100 rounded-xl p-1 flex w-full lg:w-fit">
                
                <button
                  onClick={() => setActiveTab("corporate")}
                  className={`flex-1 lg:flex-none px-4 py-2 rounded-lg transition-all duration-300 font-poppins font-semibold text-sm sm:text-base
                    ${
                      activeTab === "corporate"
                        ? "bg-white text-royalBlue shadow-sm"
                        : "text-gray-600 hover:text-royalBlue"
                    }`}
                >
                  Corporates
                </button>

                <button
                  onClick={() => setActiveTab("provider")}
                  className={`flex-1 lg:flex-none px-4 py-2 rounded-lg transition-all duration-300 font-poppins font-semibold text-sm sm:text-base
                    ${
                      activeTab === "provider"
                        ? "bg-white text-royalBlue shadow-sm"
                        : "text-gray-600 hover:text-royalBlue"
                    }`}
                >
                  Providers
                </button>
              </div> */}

              {/* CORPORATE FORM */}
              {/* {activeTab === "corporate" && (
                <form className="mt-6">
                  
                  <div className="grid md:grid-cols-2 gap-4">
                    
                    <InputFieldCompact
                      icon={<Building2 size={16} />}
                      label="Company Name"
                      placeholder="Enter company name"
                    />

                    <InputFieldCompact
                      icon={<User size={16} />}
                      label="Contact Person"
                      placeholder="Enter contact person"
                    />

                    <InputFieldCompact
                      icon={<Mail size={16} />}
                      label="Email"
                      placeholder="Enter email address"
                    />

                    <InputFieldCompact
                      icon={<Phone size={16} />}
                      label="Phone"
                      placeholder="Enter phone number"
                    />

                    <div className="md:col-span-2">
                      <InputFieldCompact
                        icon={<Users size={16} />}
                        label="Number of Employees"
                        placeholder="Enter employee count"
                      />
                    </div>
                  </div>

                  <button
                    type="submit"
                    className="group mt-6 w-full md:w-auto bg-gradient-to-r from-royalBlue to-royalGreen text-white rounded-xl px-5 py-2.5 font-poppins font-semibold shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 flex items-center justify-center gap-2 text-sm sm:text-base"
                  >
                    Register Your Company
                    <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform duration-300" />
                  </button>
                </form>
              )} */}

              {/* PROVIDER FORM */}
              <br />
              <form className="mt-20">
                <div className="flex flex-col sm:flex-row flex-wrap gap-3">

                  <button
                    type="button"
                    onClick={() =>
                      window.open(
                        "#",
                        "_blank"
                      )
                    }
                    className="group flex-1 min-w-[220px] bg-gradient-to-r from-royalBlue to-royalGreen text-white rounded-2xl px-5 py-3 font-poppins font-semibold shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 flex items-center justify-center gap-2"
                  >
                    Franchise with Livmo Health
                    <ArrowRight
                      size={16}
                      className="group-hover:translate-x-1 transition-transform duration-300"
                    />
                  </button>

                  <a
                    href="https://pay.livmohealth.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group flex-1 min-w-[220px] bg-gradient-to-r from-royalBlue to-royalGreen text-white rounded-2xl px-5 py-3 font-poppins font-semibold shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 flex items-center justify-center gap-2"
                  >
                    Subscribe to Livmo Health
                    <ArrowRight
                      size={16}
                      className="group-hover:translate-x-1 transition-transform duration-300"
                    />
                  </a>

                  <a
                    href="https://tinyurl.com/livmohealthvolunteer"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group flex-1 min-w-[220px] bg-gradient-to-r from-royalBlue to-royalGreen text-white rounded-2xl px-5 py-3 font-poppins font-semibold shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 flex items-center justify-center gap-2"
                  >
                    Join as Affiliate
                    <ArrowRight
                      size={16}
                      className="group-hover:translate-x-1 transition-transform duration-300"
                    />
                  </a>

                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

// Compact Input Field Component
// const InputFieldCompact = ({ icon, label, placeholder }) => {
//   return (
//     <div>
//       <label className="block mb-1.5 text-darkblue font-poppins font-medium text-xs sm:text-sm">
//         {label}
//       </label>
//       <div className="flex items-center gap-2 border border-gray-200 bg-white rounded-lg px-3 py-2 focus-within:border-royalBlue focus-within:ring-1 focus-within:ring-royalBlue/20 transition-all duration-200">
//         <div className="text-royalBlue/70 shrink-0">{icon}</div>
//         <input
//           type="text"
//           placeholder={placeholder}
//           className="w-full bg-transparent outline-none font-poppins text-gray-700 placeholder:text-gray-400 text-sm sm:text-base"
//         />
//       </div>
//     </div>
//   );
// };

export default Contact;